import React from "react";
import { Chip } from "@heroui/react";

/**
 * A React functional component that renders a Chip representing the given theme value.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.value] - Optional theme value to display.
 * @returns {JSX.Element|null} The Chip component if a value is provided, otherwise null.
 */
const Theme: React.FC<{ value?: string }> = ({ value }) => {
  if (!value) return null;
  return (
    <Chip
      variant="bordered"
      size="sm"
      radius="none"
      className="border-1 bg-white"
    >
      {value}
    </Chip>
  );
};

export default Theme;
